import React from 'react';

const ValidationIcon = ({ fieldName, formData, errors }) => {
  const hasError = errors[fieldName] && errors[fieldName] !== 'initial';
  const hasSuccess = formData[fieldName] !== '' && errors[fieldName] !== 'initial';

  if (hasError) {
    return <i className="bi bi-exclamation-diamond input-icon-failure"></i>;
  } else if (hasSuccess) {
    return <i className="bi bi-check-circle input-icon-success"></i>;
  } else {
    return null;
  }
};

export default ValidationIcon;

export const getInputClassNames = (fieldName, formData, errors) => {
    const hasError = errors[fieldName] && errors[fieldName] !== 'initial';
    const hasSuccess = formData[fieldName] !== '' && errors[fieldName] !== 'initial';
  
    return `form-control login-form-control ${hasError ? 'input-invalid-border-color' : hasSuccess ? 'input-valid-border-color' : ''}`;
  };
  export const getInputClassNamesUser = (fieldName, formData, errors) => {
    const hasError = errors[fieldName] && errors[fieldName] !== 'initial';
    const hasSuccess = formData[fieldName] !== '' && errors[fieldName] !== 'initial';
  
    return `form-control login-form-control ${hasError ? 'input-invalid-border-background-color' : hasSuccess ? 'input-valid-border-color' : ''}`;
  };

  export const ErrorMessage = ({ fieldName, errors, className }) => {
    return errors[fieldName] && errors[fieldName] !== 'initial' ? (
      <p className={`custom-error-message ${className}`}>{errors[fieldName]}</p>
    ) : null;
  };
  